import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatOptionModule} from "@angular/material/core"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatFormFieldModule} from "@angular/material/form-field"
import {MatInputModule} from "@angular/material/input"
import {MatMenuModule} from "@angular/material/menu"
import {MatSelectModule} from "@angular/material/select"
import {AddItemDialogComponent} from "@common/components/dialogs/add-item-dialog/add-item-dialog.component"
import {InputContainerComponent} from "@common/components/inputs/input-container/input-container.component"
import {StringInputComponent} from "@common/components/inputs/string-input/string-input.component"
import {Labels} from "@labels"
import {EditTaskTypeDialogFragment} from "@platform/components/task-types/edit-task-type-dialog/edit-task-type-dialog.generated"

export type EditTaskTypeDialogData = {
    taskTypeInfo: EditTaskTypeDialogFragment
    delete?: boolean
    edit?: boolean
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-edit-task-type-dialog",
    templateUrl: "edit-task-type-dialog.component.html",
    styleUrl: "edit-task-type-dialog.component.scss",
    imports: [
        MatInputModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatMenuModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        AddItemDialogComponent,
        InputContainerComponent,
        StringInputComponent,
    ],
})
export class EditTaskTypeDialogComponent {
    readonly $isLoading = signal(false)
    readonly dialogRef = inject(MatDialogRef<EditTaskTypeDialogComponent>)
    readonly data = inject<EditTaskTypeDialogData>(MAT_DIALOG_DATA)
    get isFormValid(): boolean {
        return !!(this.data.taskTypeInfo.taskType && this.data.taskTypeInfo.queueGroup)
    }

    readonly title = this.data.edit ? "Edit Task Type" : "Create Task Type"

    readonly confirmButtonText = this.data.edit ? "Update" : "Create"

    onConfirm(): void {
        if (!this.isFormValid) return

        this.dialogRef.close(this.data)
    }

    onDelete(): void {
        this.data.delete = true
        this.dialogRef.close(this.data)
    }

    protected readonly Labels = Labels
}
